@if (isLoading) {
  <div class="de-loader__overlay" style="z-index: 9999">
    <img src="assets/loader.svg" class="de-loader__svg-container" />
  </div>
}
